import './style.scss';
import 'swiper/swiper.scss';
import Swiper from "swiper";
import { Navigation, Autoplay } from 'swiper/modules';

export function treatments_slider_block() {

    const blocks = document.querySelectorAll('.treatments_slider_block');
    if (!blocks.length) return;

    blocks.forEach((block) => {

        const swiperContainer = block.querySelector('.treatments-swiper');
        if (!swiperContainer) return;

        const nextBtn = block.querySelector('.swiper-button-next');
        const prevBtn = block.querySelector('.swiper-button-prev');

        const slideCount = swiperContainer.querySelectorAll('.swiper-slide').length;

        const hideNav = () => {
            if (nextBtn) nextBtn.style.display = "none";
            if (prevBtn) prevBtn.style.display = "none";
        };

        const w = window.innerWidth;

        if (w >= 1440 && slideCount <= 4) hideNav();
        else if (w >= 992 && w < 1440 && slideCount <= 3) hideNav();
        else if (w >= 768 && w < 992 && slideCount <= 2) hideNav();
        else if (w < 768 && slideCount <= 1) hideNav();

        new Swiper(swiperContainer, {
            slidesPerView: 1.1,
            spaceBetween: 24,
            slidesOffsetAfter: 44,
            speed: 500,
            loop: true,
            breakpoints: {
                768: { slidesPerView: 2.206 },
                992: { slidesPerView: 2.95 },
                1280: { slidesPerView: 3.66 },
                1440: { slidesPerView: 4.12 },
                1920: { slidesPerView: 5.54 },
            },

            modules: [Navigation, Autoplay],
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            autoplay: {
                // delay: 5000,
            },
        });

    });
}
